import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@workboard/action-item';
import { RagListProps } from '../../../types/sidePanel.types';
import * as SidePanelAction from '../../../actions/sidePanel.actions';
import { updateWsGraphData } from '../../../utils/board';
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside';
import { IconStateWrapper } from './iconWrapper';

const RagListComp = (props: RagListProps) => {
  const { t } = useTranslation();
  const {
    aiId, tagId, columnId, srcVal, values
  } = props;

  const [ref] = useOnClickOutside(() => {
    if (typeof props.hideShowListPopup === 'function') {
      props.hideShowListPopup();
    }
  });

  const onRagChanges = (item) => {
    if (srcVal == 'act') {
      if (aiId) {
        props.hideShowListPopup();
        props.dispatch(SidePanelAction.boardAiRagChange(aiId, item.value, columnId));
        $.post(
          `${wbConfig.baseUrl}/activity/rag_act`,
          { rag: item.value, act_id: aiId },
          (data, status) => {
            updateWsGraphData(tagId);
          }
        );
      }
    } else if (srcVal == 'automation') {
      props.saveTitleAndValue('ragTitle', item.label, 'ragVal', item.value);
    }
  }

  const automationClass = (srcVal == 'automation') ? 'automationAttrWidth' : '';

  if (srcVal == 'automation') {
    values.unshift({ value: '', label: t('None') });
  }

  return (
    <div ref={ref} className={`ragListDivOuterWrap ${automationClass}`}>
      <div className="attrLabel">{t('CONFIDENCE')}</div>
      {values.map((item: any, index: number) => (
        <div
          key={`rag_${item.value}`}
          className="ragVal attrValFont clickable"
          data-value={item.value}
          onClick={() => onRagChanges(item)}
        >
          <IconStateWrapper isSourceFromAct={(srcVal == 'act')}>
            {
              item?.icons?.component
                ? <Icon name={item?.icons?.component} width="16" height="16" />
                : ''
            }
          </IconStateWrapper>
          <div className="displayInlineB">{item.label}</div>
        </div>
      ))}
    </div>
  );
}

export default RagListComp;
